import React from 'react';
import {View, ActivityIndicator, StyleSheet} from 'react-native';
import {Colors} from '..';
import {ComponentProps} from './ComponentProps';

type LoaderSize = 's' | 'l';

interface LoaderProps extends ComponentProps {
  size?: LoaderSize;
  fillsParent?: boolean;
}

export const LoaderBrandWhite = (props: LoaderProps) => {
  return <Loader {...{...props, color: Colors.brandWhite}} />;
};

export const LoaderBrandBase = (props: LoaderProps) => {
  return <Loader {...{...props, color: Colors.brandBase}} />;
};

export const LoaderNeutralLighter = (props: LoaderProps) => {
  return <Loader {...{...props, color: Colors.neutralLighter}} />;
};

interface LoaderPropsPrivate extends LoaderProps {
  color: string;
}

const Loader = (props: LoaderPropsPrivate) => {
  const size = props.size ?? 's';
  let containerStyle = [props.containerStyle];
  const fillsParent = props.fillsParent ?? false;
  if (fillsParent) {
    containerStyle = [props.containerStyle, styles.containerFillsParent];
  }
  return (
    <View style={containerStyle}>
      <ActivityIndicator size={size === 's' ? 'small' : 'large'} color={props.color} testID={props.testID} />
    </View>
  );
};

const styles = StyleSheet.create({
  containerFillsParent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
